import { API_ENDPOINTS, wpAPI_ENDPOINTS } from "../constants/apiConfig";
import { makeRequest } from "../middleware/axiosMiddleware";
import {
  makeRequestForBmcGetAllSpecialties,
  makeRequestForWP,
} from "../middleware/axiosForWordpress";

export const dashboardservice = {
  logout,
  getProfile,
  saveProfile,
  saveProfileImg,
  removeProfileImg,
  getConditions,
  getBannerImg,
  getCounsltedDoc,
  askDoctor,
  feedback,
  contactUs,
  getInsurence,
  getAllNews,
  getSpecificNews,
  getAllMedia,
  getSpecificMedia,
  getAllHealthPackages,
  getSpecificHealthPackage,
  bookHealthPackage,
  getTermsAndCondition,
  getPrivacyPolicy,
  getRestrictedInsurance,
  getPatientDetails,
  requestCallback,
};

async function logout() {
  const apiPath = API_ENDPOINTS.LOGOUT;
  const options = {
    path: apiPath,
    method: "POST",
    bodyObj: {},
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  return await makeRequest(options);
}
async function getProfile() {
  const apiPath = API_ENDPOINTS.GET_PROFILE;
  const options = {
    path: apiPath,
    method: "GET",
    bodyObj: {},
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  return await makeRequest(options);
}

async function saveProfile(data: any) {
  const apiPath = API_ENDPOINTS.SAVE_PROFILE;
  const options = {
    path: apiPath,
    method: "POST",
    bodyObj: {
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      mobile: data.mobile,
      callingCode: data.callingCode,
      dateOfBirth: data.dateOfBirth,
      genderId: data.genderId,
      countryId: data.countryId,
      documentTypeId: data.documentTypeId,
      documentId: data.documentId,
    },
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  return await makeRequest(options);
}

async function saveProfileImg(data: any) {
  const apiPath = API_ENDPOINTS.SAVE_PROFILE_IMG;
  const options = {
    path: apiPath,
    method: "POST",
    formdata: data,
    customHeaders: {
      "Content-Type": "multipart/form-data",
    },
  };
  return await makeRequest(options);
}
async function removeProfileImg() {
  const apiPath = API_ENDPOINTS.DELETE_PROFILE_IMG;
  const options = {
    path: apiPath,
    method: "DELETE",
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  return await makeRequest(options);
}

async function getConditions() {
  const lang = localStorage.getItem("lang") ?? "en";
  const brand = (localStorage.getItem("brandName") || "").toLowerCase().trim();
  const apiPath =
    wpAPI_ENDPOINTS.GET_ALL_SPECIALITIES + `${lang === "ar" ? "?lang=ar" : ""}`;
  const options = {
    path: apiPath,
  };
  if (brand === "bmc") {
    return await makeRequestForBmcGetAllSpecialties(options);
  }
  return await makeRequestForWP(options);
}

async function getBannerImg(category: any) {
  const lang = localStorage.getItem("lang") ?? "en";
  const apiPath =
    wpAPI_ENDPOINTS.GET_WEB_BANNER_IMG +
    category +
    `${lang === "ar" ? "&lang=ar" : ""}`;
  const options = {
    path: apiPath,
  };
  return await makeRequestForWP(options);
}

async function getCounsltedDoc(data: any) {
  let brandName = localStorage.getItem("brandName");
  const apiPath =
    API_ENDPOINTS.GET_CONSULTED_DOC +
    "patientId=" +
    data.patientId +
    "&familyMemberId=" +
    data.familyMemberId +
    "&brandName=" +
    brandName;
  const options = {
    path: apiPath,
    method: "GET",
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  return await makeRequest(options);
}

async function askDoctor(data: any) {
  const apiPath = API_ENDPOINTS.ASK_DOCTOR;
  const options = {
    path: apiPath,
    method: "POST",
    bodyObj: {
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      mobile: data.mobile,
      callingCode: data.callingCode,
      isEmailCommunication: data.isEmailCommunication,
      isMobileCommunication: data.isMobileCommunication,
      comment: data.comment,
    },
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  return await makeRequest(options);
}

async function feedback(data: any) {
  const apiPath = API_ENDPOINTS.FEEDBACK;
  const options = {
    path: apiPath,
    method: "POST",
    bodyObj: {
      inPatient: data.inPatient,
      expierience: data.experience,
      name: data.name,
      email: data.email,
      callingCode: data.callingCode,
      mobile: data.mobile,
      comment: data.comment,
    },
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  return await makeRequest(options);
}

async function contactUs(data: any) {
  const apiPath = API_ENDPOINTS.CONTACT_US;
  const options = {
    path: apiPath,
    method: "POST",
    bodyObj: {
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      mobile: data.mobile,
      callingCode: data.callingCode,
      message: data.message,
    },
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  return await makeRequest(options);
}

async function requestCallback(data: any) {
  const apiPath = API_ENDPOINTS.REQUEST_CALLBACK;
  const options = {
    path: apiPath,
    method: "POST",
    bodyObj: {
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      mobile: data.mobile,
      callingCode: data.callingCode,
      message: data.message,
    },
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  return await makeRequest(options);
}

async function bookHealthPackage(data: any) {
  const apiPath = API_ENDPOINTS.BOOK_HEALTH_PACKAGE;
  const options = {
    path: apiPath,
    method: "POST",
    bodyObj: {
      facilityId: [data.facilityId],
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      mobile: data.mobile,
      callingCode: data.callingCode,
      packageName: data.packageName,
      subPackageName: data.subPackageName,
      hospitalLocation: data.hospitalLocation,
      apptDate: data.apptDate,
    },
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  return await makeRequest(options);
}

async function getInsurence() {
  const lang = localStorage.getItem("lang") ?? "en";
  const apiPath =
    wpAPI_ENDPOINTS.GET_ALL_INSURENCE + `${lang === "ar" ? "?lang=ar" : ""}`;
  const options = {
    path: apiPath,
    method: "GET",
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  return await makeRequestForWP(options);
}

async function getAllNews() {
  const lang = localStorage.getItem("lang") ?? "en";
  const apiPath =
    wpAPI_ENDPOINTS.GET_ALL_NEWS + `${lang === "ar" ? "?lang=ar" : ""}`;
  const options = {
    path: apiPath,
    method: "GET",
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  return await makeRequestForWP(options);
}

async function getSpecificNews(data: any) {
  const lang = localStorage.getItem("lang") ?? "en";
  const apiPath =
    wpAPI_ENDPOINTS.GET_SPECIFIC_NEWS +
    data.newsId +
    `${lang === "ar" ? "&lang=ar" : ""}`;
  const options = {
    path: apiPath,
    method: "GET",
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  return await makeRequestForWP(options);
}

async function getAllMedia() {
  const lang = localStorage.getItem("lang") ?? "en";
  const apiPath =
    wpAPI_ENDPOINTS.GET_ALL_MEDIA + `${lang === "ar" ? "?lang=ar" : ""}`;
  const options = {
    path: apiPath,
    method: "GET",
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  return await makeRequestForWP(options);
}

async function getSpecificMedia(data: any) {
  const lang = localStorage.getItem("lang") ?? "en";
  const apiPath =
    wpAPI_ENDPOINTS.GET_SPECIFIC_MEDIA +
    data.mediaId +
    `${lang === "ar" ? "&lang=ar" : ""}`;
  const options = {
    path: apiPath,
    method: "GET",
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  return await makeRequestForWP(options);
}

async function getAllHealthPackages() {
  const lang = localStorage.getItem("lang") ?? "en";
  const apiPath =
    wpAPI_ENDPOINTS.GET_ALL_HEALTHPACKAGES +
    `${lang === "ar" ? "&lang=ar" : ""}`;
  const options = {
    path: apiPath,
    method: "GET",
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  return await makeRequestForWP(options);
}

async function getSpecificHealthPackage(packageName: any) {
  const lang = localStorage.getItem("lang") ?? "en";
  const apiPath =
    wpAPI_ENDPOINTS.GET_SPECIFIC_HEALTHPACKAGE +
    packageName +
    `${lang === "ar" ? "&lang=ar" : ""}`;
  const options = {
    path: apiPath,
    method: "GET",
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  return await makeRequestForWP(options);
}

async function getTermsAndCondition() {
  const lang = localStorage.getItem("lang") ?? "en";
  const apiPath =
    wpAPI_ENDPOINTS.GET_TERMSNCONDITION + `${lang === "ar" ? "?lang=ar" : ""}`;
  const options = {
    path: apiPath,
    method: "GET",
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  return await makeRequestForWP(options);
}

async function getPrivacyPolicy() {
  const lang = localStorage.getItem("lang") ?? "en";
  const apiPath =
    wpAPI_ENDPOINTS.GET_PRIVACYPOLICY + `${lang === "ar" ? "?lang=ar" : ""}`;
  const options = {
    path: apiPath,
    method: "GET",
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  return await makeRequestForWP(options);
}

async function getRestrictedInsurance(id: any) {
  const lang = localStorage.getItem("lang") ?? "en";
  const apiPath =
    wpAPI_ENDPOINTS.GET_ALL_RESTRICTED_INSURANCE +
    "?location_id=" +
    id +
    `${lang === "ar" ? "&lang=ar" : ""}`;
  const options = {
    path: apiPath,
    method: "GET",
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  return await makeRequestForWP(options);
}

async function getPatientDetails(data: any) {
  const apiPath = API_ENDPOINTS.GET_PATIENT_DETAILS;
  const options = {
    path: apiPath,
    method: "POST",
    bodyObj: {
      patientDetails: {
        his: data.his,
        patientId: data.patientId,
        institution: data.institution,
      },
    },
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  return await makeRequest(options);
}
